import Solar from "../assets/solar-md.jpg";
import Apartments from "../assets/apartments-md.jpg";
import Rust from "../assets/rust-md.jpg";
import Voting from "../assets/voting.jpg";
import Workers from "../assets/workers-md.jpg";
import * as React from "react";
import {NavLink} from "react-router-dom";

const issuesText = [
  {
    header: "Healthcare",
    key: "healthcare",
    imageSrc: Rust,
    text: (
      <>
        Making New Mexico the first state in the country to have{" "}
        <b>Universal Healthcare</b>
        <div className="w-full flex justify-end" />
      </>
    ),
  },
  {
    header: "Affordable Housing",
    key: "housing",
    imageSrc: Apartments,
    text: (
      <>
        Lowering the cost of living by focusing on one of the largest costs for
        most New Mexicans: the <b>Cost of Housing</b>
        <div className="w-full flex justify-end" />
      </>
    ),
  },
  {
    header: "Labor",
    key: "labor",
    imageSrc: Workers,
    text: (
      <>
        Fighting for our hard-working labor force to be able to afford life in
        our beautiful state. A <b>higher wage</b>,{" "}
        <b>stronger labor and union protections</b>,{" "}
        <b>paid family and medical leave</b>, and more are essential to
        strengthening our workforce.
      </>
    ),
  },
  {
    header: "Environment",
    key: "environment",
    imageSrc: Solar,
    text: (
      <>
        Using our Sovereign Wealth Fund to fund{" "}
        <b>Renewable Energy Initiatives</b>, protect our wildlife and
        environment, and make New Mexico carbon-neutral
        <div className="w-full flex justify-end" />
      </>
    ),
  },
  {
    header: "",
    key: "More",
    imageSrc: Voting,
    text: (
      <NavLink
        className={
          "pb-2 hover:border-b-blue-400 transition-colors max-w-max text-3xl text-black/90 hover:text-blue-400"
        }
        to={"/issues"}
      >
        And many more!
      </NavLink>
    ),
  },
];

const ListWithDepth = ({ textToIterate }: { textToIterate: React.ReactNode }) =>
    (
        <span className={"max-w-[600px] list-disc inline-block list-outside flex-col text-center gap-2 min-h-max"} role="list">
            {
                (Array.isArray(textToIterate)) ?
                    textToIterate?.map((textOrArr, ind) =>
                        (typeof textOrArr === "string" ?
                            <p key={`text-${ ind }`} className={"text-sm md:text-lg py-2"}>{textOrArr}</p> :
                            <ListWithDepth textToIterate={textOrArr}/>),
                    )
                    :
                    (textToIterate)
            }
        </span>
    );


export const MiniIssues = () => {

    return (
        <>
            {
                issuesText.map((issue, ind) => {
                    return (<Issue issue={issue} ind={ind} key={issue.key}/>);
                },
                )
            }
        </>
    );
};

type IssueType = { header: string, text?: string | React.ReactNode, imageSrc: string, label?: string };

const Issue = ({ issue, ind }: { issue: IssueType, ind: number }) => {
    const { header, text, imageSrc } = issue;
    return (
      <div
        style={{ backgroundImage: `url(${imageSrc})` }}
        className={
          "relative w-full h-[50vh] bg-cover bg-fixed bg-center bg-no-repeat"
        }
      >
        <div id={`scroll-${ind}`}></div>
        <div
          className={
            "bg-gradient-to-b flex flex-col from-sky-50/95 to-sky-50/75 text-black/80 flex flex-col justify-center items-center px-8  py-8 min-h-max h-[50vh] gap-4 w-full z-10"
          }
        >
          <p className={"text-3xl md:text-5xl"}>
            {ind <= 3 && (
              <b className={ind === 0 ? "text-4xl md:text-6xl" : ""}>
                {ind + 1}.
              </b>
            )}{" "}
            {header}
          </p>
          <ListWithDepth textToIterate={text} />
          <NavLink
            className={
              "border-b-2 pb-1 border-b-sky-800 hover:border-b-blue-800 transition-colors max-w-max text-xl text-sky-800 hover:text-blue-800"
            }
            to={"/issues"}
          >
            Read More
          </NavLink>
        </div>
      </div>
    );
};
